import angular from 'angular';
import IComplianceAppDataService from './IComplianceApp.data.service';

let _vendorManagementHandlersPathObject; // TODO: remove this and the reference to never used .ashx file below.
let _documentManagementHandlersDirectory; // TODO: remove this and the reference to never used .ashx file below.
let _ajaxManagerHandlerUrl; // TODO: remove this and the reference to never used .ashx file below.
let _vendorsHandlersDirectory; // TODO: remove this and the reference to never used .ashx file below.

class vmDataService extends IComplianceAppDataService {
  constructor(
    $http,
    utilityService, // eslint-disable-line no-shadow
  ) {
    super($http, utilityService, 'vm');
    console.log('app.services.vmDataService created');
  }

  // ///////////// Vendor Management ///////////////////
  // initVendorManagement() {
  //   return this.$http({
  //     url: `${this.apiRootUrl}/vm/vendorManagement/initVendorManagement`,
  //     method: 'GET',
  //     params: {}
  //   });
  // }

  initVendorManagement(serviceId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendorManagement/init`,
      method: 'GET',
      params: {
        serviceId,
      },
    });
  }

  sendRemindersAlert(alertList) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendorManagement/sendReminders`,
      method: 'PUT',
      data: JSON.stringify(alertList),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  // ///////////// Master Vendors ///////////////////
  getMasterVendors() {
    return this.$http.get(`${this.apiRootUrl}/org/masterVendor`);
  }

  getMasterVendor(masterVendorId) {
    return this.$http({
      url: `${this.apiRootUrl}/org/masterVendor/${masterVendorId}`,
      method: 'GET',
    });
  }

  validateMasterVendorDuplicateName(masterVendorId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/org/masterVendor/checkExists/`,
      method: 'GET',
      params: {
        id: masterVendorId,
        name,
      },
    });
  }

  saveMasterVendor(masterVendor) {
    if (masterVendor.masterVendorId > 0) {
      // Update existing
      return this.$http({
        url: `${this.apiRootUrl}/org/masterVendor/${masterVendor.masterVendorId}`,
        method: 'PUT',
        data: this.serializeData(masterVendor),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    // Save new
    return this.$http({
      url: `${this.apiRootUrl}/org/masterVendor`,
      method: 'POST',
      data: this.serializeData(masterVendor),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteMasterVendor(masterVendorId) {
    return this.$http({
      url: `${this.apiRootUrl}/org/masterVendor/${masterVendorId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Master Products ///////////////////
  getMasterProducts(masterVendorId) {
    return this.$http.get(`${this.apiRootUrl}/org/masterProduct/byMasterVendor`, {
      params: {
        masterVendorId,
      },
    });
  }

  getMasterProduct(masterProductId) {
    return this.$http({
      url: `${this.apiRootUrl}/org/masterProduct/${masterProductId}`,
      method: 'GET',
    });
  }

  validateMasterProductDuplicateName(masterVendorId, masterProductId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/org/masterProduct/checkExists/`,
      method: 'GET',
      params: {
        id: masterProductId,
        masterVendorId,
        name,
      },
    });
  }

  saveMasterProduct(masterProduct) {
    if (masterProduct.masterProductId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/org/masterProduct/${masterProduct.masterProductId}`,
        method: 'PUT',
        data: this.serializeData(masterProduct),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/org/masterProduct`,
      method: 'POST',
      data: this.serializeData(masterProduct),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteMasterProduct(masterProductId) {
    return this.$http({
      url: `${this.apiRootUrl}/org/masterProduct/${masterProductId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Document Management ///////////////////
  moveDocument(documentId, newFolderId, documentTypeId) {
    return this.$http.post(
      `${_documentManagementHandlersDirectory}moveDocument.ashx`,
      {},
      {
        params: {
          documentId,
          newFolderId,
          documentTypeId,
          storeRootKey: 'VMDocumentStorageRoot',
        },
      },
    );
  }

  saveFolder(folder) {
    return this.$http({
      url: `${_documentManagementHandlersDirectory}saveFolder.ashx`,
      method: 'GET',
      params: {
        folderId: folder.FolderID,
        currentFolderName: folder.CurrentFolderName,
        newFolderName: folder.NewFolderName,
        storeRootKey: folder.StorageRoot,
      },
    });
  }

  // ///////////// Vendor Managers ///////////////////
  getVendorManagers(vendorId, includeAllVendorManagers) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendorManager/byVendor`,
      method: 'GET',
      params: {
        vendorId,
        includeAllVendorManagers,
      },
    });
  }

  getVendorManagersByCustomer(customerId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendorManager/byCustomer`,
      method: 'GET',
      params: {
        customerId,
      },
    });
  }

  getVendorManager(vendorManagerId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendorManager/${vendorManagerId}`,
      method: 'GET',
    });
  }

  saveVendorManager(vendorManager) {
    if (vendorManager.vendorManagerId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/vm/vendorManager/${vendorManager.vendorManagerId}`,
        method: 'PUT',
        data: this.serializeData(vendorManager),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendorManager`,
      method: 'POST',
      data: this.serializeData(vendorManager),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteVendorManager(vendorManagerId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendorManager/${vendorManagerId}`,
      method: 'DELETE',
    });
  }

  assignVendorManagersByVendor(vendorId, vendorManagerIds) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendorManager/assignByVendor`,
      method: 'PUT',
      params: {
        vendorId,
        vendorManagerIds,
      },
    });
  }

  assignVendorManager(vendorManagerId, vendorIds) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendorManager/assign`,
      method: 'PUT',
      params: {
        vendorManagerId,
        echo: true,
      },
      data: JSON.stringify(vendorIds),
      headers: { 'Content-Type': 'application/json' },
    });
  }

  unassignVendorManager(vendorManagerId, vendorId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendorManager/unassign`,
      method: 'PUT',
      params: {
        id: vendorManagerId,
        vendorId,
      },
    });
  }

  // ///////////// Custom Risk Controls ///////////////////
  saveCustomRiskControl(riskControl) {
    if (riskControl.riskControlId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/vm/riskControl/${riskControl.riskControlId}`,
        method: 'PUT',
        data: this.serializeData(riskControl),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControl`,
      method: 'POST',
      data: this.serializeData(riskControl),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getCustomRiskControls(customerId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControl/byCustomer`,
      method: 'GET',
      params: {
        customerId,
      },
    });
  }

  getCustomRiskControl(riskControlId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControl/${riskControlId}`,
      method: 'GET',
    });
  }

  deleteCustomRiskControl(riskControlId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControl/${riskControlId}`,
      method: 'DELETE',
    });
  }

  saveCustomRiskControlQuestion(riskControlQuestion) {
    if (riskControlQuestion.riskControlQuestionId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/vm/riskControlQuestion/${riskControlQuestion.riskControlQuestionId}`,
        method: 'PUT',
        data: this.serializeData(riskControlQuestion),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlQuestion`,
      method: 'POST',
      data: this.serializeData(riskControlQuestion),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getCustomRiskControlQuestions(riskControlId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlQuestion/byRiskControl`,
      method: 'GET',
      params: {
        riskControlId,
      },
    });
  }

  getCustomRiskControlQuestion(riskControlQuestionId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlQuestion/${riskControlQuestionId}`,
      method: 'GET',
    });
  }

  deleteCustomRiskControlQuestion(riskControlQuestionId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlQuestion/${riskControlQuestionId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Settings ///////////////////
  getRiskTierInformation(customerId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskTierRating/byCustomer`,
      method: 'GET',
      params: {
        customerId,
      },
    });
  }

  resetCustomerData(resetAction, emailAddressSuffix) {
    return this.$http.post(
      `${_vendorManagementHandlersPathObject.settings.dataReset.root}resetCustomerData.ashx`,
      {},
      {
        params: {
          resetAction,
          emailAddressSuffix,
        },
      },
    );
  }

  saveSettings(settingsDefaults) {
    if (settingsDefaults.settingsDefaultsId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/vm/setting/${settingsDefaults.settingsDefaultsId}`,
        method: 'PUT',
        data: this.serializeData(settingsDefaults),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/vm/setting`,
      method: 'POST',
      data: this.serializeData(settingsDefaults),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // ///////////// Vendors ///////////////////
  checkVendorExists(vendorId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendor/exists/`,
      method: 'GET',
      params: {
        id: vendorId,
        name,
      },
    });
  }

  getVendorsByCustomer(customerId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendor/byCustomer`,
      method: 'GET',
      params: {
        customerId,
      },
    });
  }

  saveVendor(vendor, echo) {
    if (vendor.vendorId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/vm/vendor/${vendor.vendorId}`,
        method: 'PUT',
        data: this.serializeData(vendor),
        params: {
          echo,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendor`,
      method: 'POST',
      data: this.serializeData(vendor),
      params: {
        echo,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteVendor(vendorId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendor/${vendorId}`,
      method: 'DELETE',
    });
  }

  getBaseVendors() {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendors/base`,
      method: 'GET',
      params: {},
    });
  }

  getVendors(serviceId, pageNumber, pageSize, statusId, returnCount) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendor`,
      method: 'GET',
      params: {
        serviceId,
        page: pageNumber,
        size: pageSize,
        status: statusId,
        returnCount,
      },
    });
  }

  getVendorsByVendorManagers(vendorManagerId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendor/byVendorManager`,
      method: 'GET',
      params: {
        vendorManagerId,
      },
    });
  }

  getVendor(vendorId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendor/${vendorId}`,
      method: 'GET',
    });
  }

  getVendorDetails(vendorId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendor/detail/${vendorId}`,
      method: 'GET',
    });
  }

  getVendorCustom(vendorId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendor/custom/${vendorId}`,
      method: 'GET',
    });
  }

  getVendorIdByProductId(productId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/vendor/byProduct`,
      method: 'GET',
      params: {
        productId,
      },
    });
  }

  checkVendorName(vendorId, vendorName) {
    return this.$http({
      url: _ajaxManagerHandlerUrl,
      method: 'GET',
      params: {
        action: 'checkVendorName',
        vendorId,
        vendorName,
      },
    });
  }

  getVendorDetailReport() {
    return this.getReportByName('VMVendorDetail');
  }

  saveAlertRecipient(alertRecipient) {
    return this.$http.post(
      `${_vendorsHandlersDirectory}saveAlertRecipient.ashx`,
      {},
      {
        params: {
          alertRecipientId: alertRecipient.AlertRecipientID,
          vendorId: alertRecipient.VendorID,
          email: alertRecipient.Email,
          name: alertRecipient.Name,
        },
      },
    );
  }

  deleteAlertRecipient(alertRecipientId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/alertRecipient/${alertRecipientId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Products ///////////////////
  getProducts(vendorId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/product/byVendor/${vendorId}`,
      method: 'GET',
    });
  }

  getProduct(productId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/product/${productId}`,
      method: 'GET',
    });
  }

  getProductDetails(productId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/product/detail/${productId}`,
      method: 'GET',
    });
  }

  saveProduct(product) {
    if (product.productId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/vm/product/${product.productId}`,
        method: 'PUT',
        data: this.serializeData(product),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/vm/product`,
      method: 'POST',
      data: this.serializeData(product),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteProduct(productId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/product/${productId}`,
      method: 'DELETE',
    });
  }

  checkProductExists(vendorId, productId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/product/exists`,
      method: 'GET',
      params: {
        vendorId,
        id: productId,
        name,
      },
    });
  }

  updateProductAlertFrequency(id) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/product/${id}/updateAlertFrequency`,
      method: 'PUT',
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getProductDetailReport() {
    return this.getReportByName('VMProductDetail');
  }

  attachProductDocuments(productId, documents) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/product/${productId}/attachDocument?echo=true`,
      method: 'PUT',
      data: this.serializeData({
        documentIds: documents,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachProductDocument(id) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/productDocument/${id}/detach`,
      method: 'PUT',
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getContacts(productId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/contact/byProduct`,
      method: 'GET',
      params: {
        productId,
      },
    });
  }

  getContactDetails(contactId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/contact/${contactId}`,
      method: 'GET',
    });
  }

  saveContact(contact) {
    if (contact.contactId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/vm/contact/${contact.contactId}`,
        method: 'PUT',
        data: this.serializeData(contact),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/vm/contact`,
      method: 'POST',
      data: this.serializeData(contact),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteContact(contactId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/contact/${contactId}`,
      method: 'DELETE',
    });
  }

  checkContactExists(productId, contactId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/contact/exists`,
      method: 'GET',
      params: {
        productId,
        id: contactId,
        name,
      },
    });
  }

  // ///////////// Product SOC Comments ///////////////////

  getSOCCommentsForProduct(productId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/productSOCComment/byProduct`,
      method: 'GET',
      params: {
        productId,
      },
    });
  }

  getSOCComment(productSocCommentId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/productSOCComment/${productSocCommentId}`,
      method: 'GET',
    });
  }

  saveSOCComment(productSocComment) {
    if (productSocComment.productSocCommentId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/vm/productSOCComment/${productSocComment.productSocCommentId}`,
        method: 'PUT',
        data: this.serializeData(productSocComment),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/vm/productSOCComment`,
      method: 'POST',
      data: this.serializeData(productSocComment),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteSOCComment(productSocCommentId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/productSOCComment/${productSocCommentId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Product Insurance Comments ///////////////////

  getInsuranceCommentsForProduct(productId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/productInsuranceComment/byProduct`,
      method: 'GET',
      params: {
        productId,
      },
    });
  }

  getInsuranceComment(productInsuranceCommentId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/productInsuranceComment/${productInsuranceCommentId}`,
      method: 'GET',
    });
  }

  saveInsuranceComment(productInsuranceComment) {
    if (productInsuranceComment.productInsuranceCommentId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/vm/productInsuranceComment/${productInsuranceComment.productInsuranceCommentId}`,
        method: 'PUT',
        data: this.serializeData(productInsuranceComment),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/vm/productInsuranceComment`,
      method: 'POST',
      data: this.serializeData(productInsuranceComment),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteInsuranceComment(productInsuranceCommentId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/productInsuranceComment/${productInsuranceCommentId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Risk Assessments ///////////////////
  getRiskCategories() {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskCategory`,
      method: 'GET',
    });
  }

  getRiskCategoryWeight(customerId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskCategoryWeight/byCustomer`,
      method: 'GET',
      params: {
        customerId,
      },
    });
  }

  saveBulkRiskCategoryWeights(riskCategoryWeights) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskCategoryWeight/saveBulk`,
      method: 'POST',
      data: JSON.stringify(riskCategoryWeights),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getAssessmentAnswers(productId, includeDisabled) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskAssessment/byProduct`,
      method: 'GET',
      params: {
        productId,
        includeDisabled,
      },
    });
  }

  getAssessmentQuestions(productId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskAssessmentQuestion/byProduct`,
      method: 'GET',
      params: {
        productId,
      },
    });
  }

  saveRiskAssessment(riskAssessments) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/assessment/`,
      method: 'POST',
      data: JSON.stringify({
        productId: riskAssessments.ProductID,
        riskAssessmentQuestions: JSON.stringify(riskAssessments.RiskAssessmentQuestions),
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  createRiskAssessment(productId, riskAssessmentQuestions) {
    console.log(riskAssessmentQuestions);
    return this.$http({
      method: 'POST',
      url: `${this.apiRootUrl}/vm/assessment/addNew`,
      data: JSON.stringify({
        productId,
        riskAssessmentQuestions,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  // ///////////// Control Reviews ///////////////////
  getRiskControl(riskControlId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControl/${riskControlId}`,
      method: 'GET',
    });
  }

  getRiskControlQuestionsByRiskControl(riskControlId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlQuestion/byRiskControl`,
      method: 'GET',
      params: {
        riskControlId,
      },
    });
  }

  getRiskControlReviewTaskControlDetails(riskControlReviewTaskControlId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTaskControl/detail/${riskControlReviewTaskControlId}`,
      method: 'GET',
    });
  }

  getControlsForProductReview(productId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControl/byProduct`,
      method: 'GET',
      params: {
        productId,
      },
    });
  }

  getRiskControlsInfoByProduct(productId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTask/customByProduct`,
      method: 'GET',
      params: {
        productId,
      },
    });
  }

  getRiskControlReviewTaskControl(riskControlReviewTaskControlId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTaskControl/${riskControlReviewTaskControlId}`,
      method: 'GET',
    });
  }

  saveRiskControlReviewTask(riskControlReviewTask) {
    if (riskControlReviewTask.riskControlReviewTaskId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/vm/riskControlReviewTask/${riskControlReviewTask.riskControlReviewTaskId}`,
        method: 'PUT',
        data: JSON.stringify(riskControlReviewTask),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/json' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTask`,
      method: 'POST',
      data: JSON.stringify(riskControlReviewTask),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  saveRiskControlReviewTaskControl(riskControlReviewTaskControl) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTaskControl/saveBulkValues`,
      method: 'PUT',
      data: JSON.stringify(riskControlReviewTaskControl),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  updateRiskControlReviewTaskControlDocuments(riskControlReviewTaskControlId, documentIds) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTaskControl/${riskControlReviewTaskControlId}/updateDocuments`,
      method: 'PUT',
      data: JSON.stringify(documentIds),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  deleteRiskControlReviewTaskControlDocuments(riskControlReviewTaskControlId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTaskControl/${riskControlReviewTaskControlId}/removeDocuments`,
      method: 'DELETE',
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  markReviewTaskControlComplete(riskControlReviewTaskControlId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTaskControl/complete/${riskControlReviewTaskControlId}`,
      method: 'PUT',
    });
  }

  markReviewTaskControlIncomplete(riskControlReviewTaskControlId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTaskControl/incomplete/${riskControlReviewTaskControlId}`,
      method: 'PUT',
    });
  }

  markControlReviewTaskComplete(riskControlReviewTaskId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTask/complete/${riskControlReviewTaskId}`,
      method: 'PUT',
    });
  }

  updateProductLastReviewDate(productId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTask/updateReviewDate/${productId}`,
      method: 'PUT',
    });
  }

  getProductRiskControlReviewTask(productId, isActive, isComplete) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTask/byProduct`,
      method: 'GET',
      params: {
        productId,
        isActive,
        isComplete,
      },
    });
  }

  deleteRiskControlReviewTask(riskControlReviewTaskId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTask/${riskControlReviewTaskId}`,
      method: 'DELETE',
    });
  }

  deleteRiskControlReviewTaskByProductId(productId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTask/byProduct`,
      method: 'DELETE',
      params: {
        productId,
      },
    });
  }

  deleteRiskControlReviewTaskControl(riskControlReviewTaskControlId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTaskControl/${riskControlReviewTaskControlId}`,
      method: 'DELETE',
    });
  }

  getRiskControlValuesByReviewTaskControlId(riskControlReviewTaskControlId) {
    return this.$http({
      url: `${this.apiRootUrl}/vm/riskControlReviewTaskControl/riskControlValues`,
      method: 'GET',
      params: {
        id: riskControlReviewTaskControlId,
      },
    });
  }

  // ///////////// Misc ///////////////////
  isControlDateVisible() {
    return this.$http({
      url: _ajaxManagerHandlerUrl,
      method: 'GET',
      params: {
        action: 'isControlDateVisible',
      },
    });
  }
}

vmDataService.$inject = ['$http', 'utilityService'];

export default angular.module('app.services.vmDataService', []).service('vmDataService', vmDataService).name;
